import * as React from 'react';
import { useIntl } from 'react-intl';

import { useTitleStore } from 'src/stores/useTitleStore';
import { billingAttemptsMessages } from 'src/features/billingAttempts/utils/messages';
import BillingAttemptsTable from 'src/features/billingAttempts/components/tables/BillingAttemptsTable';

const BillingAttemptsLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(billingAttemptsMessages.billingAttempts));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <BillingAttemptsTable />;
};

export default BillingAttemptsLayout;
